<template>
  <div class="common">
        <nav class="footer">
            <div class="footerContent">
                <div class="footerHeader">
                    <img  @click="goHome" class="logo" src="../assets/headerLogo.svg"/>
                    <ul>
                        <li @click="goHome">{{langData.header.title1}}</li>
                        <li @click="goProducts">{{langData.header.title2}}</li>
                        <li @click="goMexico">{{langData.header.title3}}</li>
                        <li @click="goAboutUs">{{langData.header.title4}}</li>
                        <li @click="goContactUs">{{langData.header.title5}}</li>
                    </ul>
                    <!-- <div class="paizhao" :style="this.language=='en'?'right: 145px;':'right: 225px'">
                        CNBV Reg. No.: 22518 Dated January 17, 2025.<br/>
                        No. Reg. CNBV: 22518 De fecha 17 de enero de 2025.
                    </div> -->
                </div>
                <div class="contactUs">
                    <div>{{langData.footer.title1}}</div>
                    <div>{{langData.footer.title2}}</div>
                    <div>{{langData.footer.title3}}</div>
                    <div>
                        <span @click="goUserAgreement" style="color:#fff;cursor: pointer;">{{langData.footer.title4}}</span>
                    </div>
                    <!-- <div>
                        <span @click="goSpecificTermConditions" style="color:#fff;cursor: pointer;">Specific Terms and Conditions</span>
                    </div> -->
                    <div>
                        <span @click="goPrivacyPolicy" style="color:#fff;cursor: pointer;">{{langData.footer.title5}}</span>
                    </div>
                </div>
                <div class="footerImg">
                    <img @click="goHome" src="../assets/headerLogo.png"/>
                </div>
                <div class="standBy">
                    Copyright © {{year}}. {{langData.footer.title6}}<br/>
                    <a href="https://www.linkedin.com/company/pandapay-mx"><img src="../assets/linkedin.png"/></a>
                </div>
            </div>
        </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../store/index";
import localStorage from "../services/localStorage.service";
const getAndSet = function(name) {
    return {
        // getter
        get: function() {
            return this.$store.state.module[name]
        },
        // setter
        set: function(newValue) {
            this.$store.state.module[name] = newValue
        }
    }
}
export default {
  name: '',
  data () {
    return {
        year:new Date().getFullYear(),
        langData: {
            home:{
                languageOption:[]
            },
        },
    }
  },
  methods:{
      goMexico(){
          this.$router.push('/mexico')
          window.scrollTo(0, 0)
      },
      goContactUs(){
          this.$router.push('/contact')
          window.scrollTo(0, 0)
      },
      goHome(){
          this.model = false
          window.scrollTo(0, 0)
          this.$router.push('/')
      },
      goProducts(){
          this.model = false
          window.scrollTo(0, 700)
          this.$router.push('/')
      },
      goAboutUs(){
          this.model = false
          window.scrollTo(0, 3850)
          this.$router.push('/')
      },
      goUserAgreement(){
          this.$router.push('/userAgreement')
          window.scrollTo(0, 0)
      },
      goPrivacyPolicy(){
          this.$router.push('/privacyPolicy')
          window.scrollTo(0, 0)
      },
      goSpecificTermConditions(){
          this.$router.push('/SpecificTermConditions')
          window.scrollTo(0, 0)
      },
        changeLanguage() {
        this.$i18n.locale = this.language;

        this.langData = this.$i18n.messages[this.$i18n.locale].message.home;
        }
  },
  created() {
    this.changeLanguage();
  },
    computed: {
		language: getAndSet('language'),
    },
    watch: {
        language: function() {
        this.changeLanguage();
        }
    },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@media all and (min-width:960px){
    .common{
        position: relative;
        width: 100%;
        .footer{
            background: #0D2436;
            width: 100%;
            .footerContent{
                width: 80%;
                margin: 0 auto;
                .footerHeader{
                    position: relative;
                    display: flex;
                    .logo{
                        width: 210px;
                        height: 42px;
                        margin-top: 120px;
                        margin-right: 30px;
                    }
                    ul{
                        position: absolute;
                        right: 0;
                        margin-top: 120px;
                        list-style: none;
                        li{
                            cursor: pointer;
                            display: inline-block;
                            // margin-left: 70px;
                            margin-left: 40px;
                            font-size: 18px;
                            font-family: OpenSans-Bold, OpenSans;
                            font-weight: bold;
                            color: #5A7184;
                        }
                        li:hover{
                            color: #FFFFFF;
                        }
                    }
                    .paizhao{
                        position: absolute;
                        right: 265px;
                        margin-top: 160px;
                        font-size: 16px;
                        font-family: OpenSans-Regular, OpenSans;
                        font-weight: 400;
                        color:#E1E1E1;
                        line-height: 40px;
                    }
                }
            }
            .footerImg{
                display: none;
            }
            .contactUs{
                margin-top: 30px;
                font-size: 16px;
                font-family: OpenSans-Regular, OpenSans;
                font-weight: 400;
                color:#E1E1E1;
                line-height: 40px;
                // span{
                //     text-decoration: underline;
                // }
            }
            .standBy{
                width: 360px;
                text-align: center;
                margin: 0 auto;
                font-size: 16px;
                font-family: OpenSans-SemiBold, OpenSans;
                font-weight: 600;
                color: #5A7184;
                margin-top: 120px;
                padding-bottom: 45px;
                line-height: 40px;
            }
        }
    }
}
@media all and (max-width:960px){
    .common{
        position: relative;
        width: 100%;
        .footer{
            background: #0D2436;
            width: 100%;
            .footerContent{
                margin: 0 18px;
                padding-top: 30px;
                .footerHeader{
                    position: relative;
                    .logo{
                        display: none;
                    }
                    ul{
                        list-style: none;
                        li{
                            cursor: pointer;
                            display: inline-block;
                            font-size: 18px;
                            font-family: OpenSans-Bold, OpenSans;
                            font-weight: bold;
                            color: #5A7184;
                            width: 140px;
                            margin-top: 25px;
                        }
                    }
                    .paizhao{
                        margin-top: 25px;
                        font-size: 14px;
                        font-family: OpenSans-Regular, OpenSans;
                        font-weight: 400;
                        color: #E1E1E1;
                        line-height: 30px;
                    }
                }
            }
            .contactUs{
                margin-top: 25px;
                font-size: 14px;
                font-family: OpenSans-Regular, OpenSans;
                font-weight: 400;
                color: #E1E1E1;
                line-height: 30px;
                // span{
                //     text-decoration: underline;
                // }
            }
            .footerImg{
                text-align: center;
                margin-top: 75px;
                img{
                    width: 148px;
                    height: 30px;
                }
            }
            .standBy{
                text-align: center;
                margin: 0 auto;
                font-size: 10px;
                font-family: OpenSans-SemiBold, OpenSans;
                font-weight: 600;
                color: #5A7184;
                line-height: 25px;
                margin-top: 30px;
                padding-bottom: 180px;
                img{
                    width: 14px;
                }
            }
        }
    }
}
</style>
<style lang="less">
</style>


// WEBPACK FOOTER //
// src/components/footer.vue